import { Box, Typography } from "@mui/material";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import PropTypes from "prop-types";

export default function JsonViewer({ page }) {

    if (!page) {
        return (
            <Box sx={{ p: 2, color: "#94a3b8" }}>
                No page selected
            </Box>
        );
    }

    return (
        <Box
            sx={{
                p: 2,
                background: "#0f172a",
                borderRadius: 2,
                height: "100%",
                overflow: "auto",
            }}
        >

            <Typography sx={{ color: "#38bdf8", mb: 2 }}>
                Page {page.page_num}
            </Typography>

            <JsonView
                src={page}
                collapsed={false}
                collapseStringsAfterLength={80}
                displayDataTypes={false}
                displayObjectSize={false}
                enableClipboard
                indentWidth={12}
                style={{
                    fontSize: 12,
                    background: "transparent",
                }}
            />
        </Box>
    );
}

JsonViewer.propTypes = {
    page: PropTypes.object,
    fileId: PropTypes.string,
};